<template>
	<form @submit.prevent="">
		<div class="form-row">
			<div class="col-12">
				<label for="title">عنوان ویجت</label>
				<input type="text" id="title" placeholder="عنوان ویجت" class="widget-input input-no-bg input-lg input-set-border w-100" v-model="data.title">
			</div>
		</div>

		<div class="form-row">
			<div class="col-12">
				<label for="title">دسته خبر</label>
				<select v-model="data.category_id" class="form-control t-widget-select widget-select-lg select-set-border">
					<option v-for="(category_id, category_title) in categories" :key="category_title" :value="category_title">{{ category_id }}</option>
				</select>
			</div>
		</div>

		<div class="form-row text-center mt-4">
			<div class="col-12">
				<a href="" @click.prevent="saveSettings()" class="m-left min-w150 tgju-btn tgju-btn-lg tgju-btn-primary"><i class="uil uil-save"></i> ذخیره</a>
			</div>
		</div>
	</form>
</template>

<script>
	export default {
		name: 'SettingsCats',
		components: {},
		props: ['data'],
		data: function () {
			return {
				categories: {
					120: 'اخبار طلا و سکه',
					121: 'اخبار بازار ارز',
					30143: 'ارزهای دیجیتال',
					112: 'اخبار نفت و انرژی',
					113: 'اخبار بورس',
					114: 'اخبار مسکن و عمران',
					115: 'اخبار خودرو',
					116: 'اخبار بانک و بیمه',
					30148: 'اخبار تولید',
					30149: 'اخبار تجارت',
					118: 'اخبار قیمت ها',
					119: 'اخبار اقتصادی',
					30145: 'اخبار جهان',
					30146: 'اخبار فناوری',
				}
			}
		},

		mounted() {

		},

		methods: {
			saveSettings() {
				let data = this.$helpers.unbindObject(this.data);

				this.$parent.saveSettings(data);
			},
		},
	}
</script>